import verifyUser from "@/lib/verify-user"
import { useEffect } from "react"

/**
 * Redirects unauthenticated users on mount. Defaults to `verifyUser`
 * (redirects to /profile/auth); cart-flow pages pass `verifyUserInCart`
 * (redirects to /cart/profile-data). Extracted from the effect boilerplate
 * previously copied across the profile pages.
 */
export function useRequireAuth(verify: () => Promise<unknown> = verifyUser): void {
  useEffect(() => {
    verify().catch(console.error)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
